<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("order_form") }}
                    </h6>
                    <nav
                        aria-label="breadcrumb"
                        class="d-none d-md-inline-block ml-md-4"
                    >
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>

                <div class="col-lg-6 col-5 text-right">
                    <!-- spec 2026-10-07-bo-form-draft-clear-design.md §3 F2 / §4 A5: leftmost of the header group -->
                    <form-clear-button class="mr-2" :disabled="isLoading" @click="clearForm" />
                    <router-link to="/backoffice/orders">
                        <base-button size="md" type="neutral">{{
                            $t("back")
                        }}</base-button>
                    </router-link>
                </div>
            </div>
        </base-header>

        <div class="row">
            <div class="container-fluid mt--6 col-lg-6">
                <div>
                    <!-- card left -->
                    <card
                        header-classes="bg-transparent"
                        footer-classes="bg-transparent"
                        body-classes="px-lg-4 py-lg-4"
                        class=" border-0  mb-4"
                    >
                        <template slot="header">
                            <div class="row">
                                <label
                                    class="col-md-3 col-form-label form-control-label"
                                >
                                    <h3 class="mb-0">
                                        {{ $t("customer_information") }}
                                    </h3>
                                </label>

                                <div class="col-md-5">
                                    <base-input
                                        :placeholder="
                                            $t('name') + ' / ' + $t('phone')
                                        "
                                        v-model="customer_keyword"
                                        class="form-control-alternative"
                                        prepend-icon="ni ni-zoom-split-in"
										v-on:keyup.enter="handleSearchCustomer"
                                    ></base-input>
                                </div>
                                <div class="col-m-2">
                                    <base-button @click="handleSearchCustomer"
                                        >Search</base-button
                                    >
                                </div>
                            </div>
                        </template>

                        <validation-observer
                            v-slot="{ handleSubmit }"
                            ref="formValidator"
                        >
                            <form
                                class="needs-validation"
                                @submit.prevent="handleSubmit(onSubmit)"
                            >
                                <div class="form-group row align-items-center">
                                    <div class="col-md-12 d-flex align-items-center flex-wrap">
                                        <base-button
                                            type="primary"
                                            size="sm"
                                            outline
                                            @click="openBirthdayModal()"
                                        >
                                            <i class="ni ni-calendar-grid-58 mr-1"></i>
                                            {{ params.recipient_birthday ? $t('edit') + ' ' + $t('birthday') : $t('birthday_set') }}
                                        </base-button>
                                        <base-button
                                            v-if="params.recipient_birthday"
                                            type="danger"
                                            size="sm"
                                            outline
                                            class="ml-2"
                                            @click="clearBirthday()"
                                        >
                                            <i class="fa fa-times mr-1"></i>
                                            {{ $t('birthday_clear') }}
                                        </base-button>
                                        <span v-if="params.recipient_birthday" class="ml-3 text-default">
                                            {{ $t('birthday') }}: {{ formatBirthdayBE(params.recipient_birthday) }}
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <base-input
                                            :label="$t('name')"
                                            :name="$t('name')"
                                            v-model="params.recipient_name"
                                            rules="required"
											maxlength="100"
                                        ></base-input>
                                    </div>
                                    <div class="col-md-6">
                                        <base-input
                                            :label="$t('phone')"
                                            :name="$t('phone')"
                                            v-model="params.recipient_phone"
                                            rules="required|numeric"
                                        ></base-input>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <div class="col-md-12">
                                        <base-input
                                            :label="$t('recipent_address')"
                                            :name="$t('recipent_address')"
                                            v-model="
                                                params.recipient_address_detail
                                            "
                                            rules="required"
											maxlength="500"
                                        ></base-input>
                                    </div>

									<div class="col-md-6">
										<base-input
											:label="$t('recipent_district')"
											:name="$t('recipent_district')"
											v-model="params.recipient_address_district"
											rules="required"
											@input="onChange"
											@keydown.down="onArrowDown"
											@keydown.up="onArrowUp"
											@keydown.enter="onEnter"
										></base-input>
										<ul
												v-show="isOpen"
												class="autocomplete-results"
											>
												<li
													v-for="(result,
													i) in filteredAddress"
													:key="i"
													@click="setResult(result)"
													class="autocomplete-result"
													:class="{
														'is-active':
															i === arrowCounter
													}"
												>
													<template
														v-if="
															result.ProvinceID == 10
														"
													>
														แขวง{{
															result.District
														}}
														เขต{{
															result.City
														}}
														จังหวัด{{ result.Province }}
														{{ result.Zipcode }}
													</template>
													<template v-else>
														ต.{{ result.District }} อ.{{
															result.City
														}}
														จ.{{ result.Province }}
														{{ result.Zipcode }}
													</template>
												</li>
											</ul>
										</div>

                                    <div class="col-md-6">
                                        <base-input :label="$t('recipent_city')" :name="$t('recipent_city')" v-model=" params.recipient_address_city " rules="required" ></base-input>
                                    </div>
                                </div>
								                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <base-input :label="$t('recipent_province')" :name="$t('recipent_province')" v-model=" params.recipient_address_province " rules="required" ></base-input>
                                    </div>

                                    <div class="col-md-6">
                                        <base-input :label="$t('recipent_zipcode')" :name="$t('recipent_zipcode')" v-model="params.recipient_zipcode" rules="required" ></base-input> </div>
                                </div>

                                <div class="form-group row">
                                    <!-- <div class="col-md-12">
                                        <base-input :label="$t('sale_channel')">
                                            <el-select v-model=" params.bo_sale_channel_id " :placeholder=" $t('sale_channel') " :label="$t('sale_channel')" filterable >
                                                <el-option v-for="option in SaleChannelTable" :key="option.id" :label="option.name" :value="option.id" > </el-option>
                                            </el-select>
                                        </base-input>
                                    </div> -->
                                    <div class="col-md-12">
                                        <base-input :label="$t('seller_note')" v-model="params.seller_note" ></base-input>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <base-input :label="$t('payment_channel')" >
                                            <el-select v-model=" params.bo_payment_method_id " :label="$t('payment_channel')" filterable @change="onPaymentChange">
                                                <el-option v-for="option in PaymentMethodTable" :key="option.id" :label="option.name" :value="option.id" > </el-option>
                                            </el-select>
                                        </base-input>
                                    </div>

									<div class="col-md-6">
                                        <base-input :label="$t('shipping_provider')" >
                                            <el-select v-model=" params.shipping_provider_id " :label="$t('shipping_provider')" filterable>
                                                <el-option v-for="option in ShippingProviderTableFilter" :key="option.id" :label="option.name" :value="option.id" > </el-option>
                                            </el-select>
                                        </base-input>
                                    </div>

									<div class="col-md-6">
                                        <base-input :name="$t('discount')" :label="$t('discount')" v-model="params.discount" rules="required|numeric"></base-input>
                                    </div>

									<div class="col-md-6" v-if="!IsCOD">
                                        <base-input :label="$t('payment_at')" >
											<flat-picker
												slot-scope="{ focus, blur }"
												@on-open="focus"
												@on-close="blur"
												:config="{ time_24hr: true ,allowInput: true, enableTime: true, dateFormat: 'Y-m-d H:i', defaultDate: new Date()}"
												:placeholder="$t('time_from')"
												class="form-control datepicker"
												v-model="params.payment_at"
											>
											</flat-picker>
										</base-input>
                                    </div>


                                    <div class="col-md-12">
                                        <base-input :label="$t('payment_slip')" :name="$t('payment_slip')" >
                                            <file-input ref="paymentSlipInput" rules="required" @change="filesChange" ></file-input>
                                        </base-input>
                                    </div>

                                    <hr />
                                    <div class="col-md-12 mt-3">
                                        <base-button size="md" type="primary" :loading="isLoading" @click="handleSaveOrder()">{{ $t("save") }}</base-button>
                                    </div>

									<div class="row mt-3" >
										<div class="col-md-12">
											<img v-if="(params.payment_files.includes('png') || params.payment_files.includes('jpg') || params.payment_files.includes('jpeg'))  && params.payment_files != '' && params.payment_files != null && params.payment_files != undefined " :src="params.payment_files" width="80%" />
										</div>
									</div>
                                </div>


                                <div class="form-group row mt--6" v-for="item in ProductSelect" :key="item.ID" >
                                    <label class="col-md-6 pl-6 col-form-label form-control-label" >
                                        {{ item.Name }}
                                    </label>
                                    <div class="col-md-3">
                                        <base-button @click.native=" handleDelete($index, item) " class="remove btn-link" type="danger" size="md" icon > <i class="text-dtac-bt fa fa-trash"></i> </base-button>
                                    </div>
                                </div>
                            </form>
                        </validation-observer>
                    </card>
                </div>
            </div>

            <div class="container-fluid mt--6 col-lg-6">
                <div>
                    <!-- card right -->
                    <card
                        class="no-border-card"
                        body-classes="px-0 pb-1"
                        footer-classes="pb-2"
                    >
                        <template slot="header">
                            <div class="row">
                                <label class="col-md-6 col-form-label form-control-label" >
                                    <h3 class="mb-0"> {{ $t("product_information") }} </h3>
                                </label>
                                <div class="col-md-6">
                                    <base-input v-model="SearchKeyword" prepend-icon="fas fa-search" :placeholder="$t('search')" > </base-input>
                                </div>
                            </div>
                        </template>
                        <div>
                            <!-- Selected Product -->
                            <div class="row">
                                <div class="col-md-12">
                                    <el-table :data="sku_selected" row-key="id" header-row-class-name="thead-light"
                                    >
                                        <!-- Productname -->
                                        <el-table-column> <template slot-scope="{ $index, row }" > {{ row.product_name }} </template> </el-table-column>
                                        <!-- skuname -->
                                        <el-table-column>
                                            <template slot-scope="{ $index, row }" > {{ row.sku_code }} </template>
                                        </el-table-column>

                                        <!-- price (with bulk-discount badge when tier active) -->
                                        <el-table-column :label="$t('price')">
                                            <template slot-scope="{ row }">
                                                <span>{{ row.price }}</span>
                                                <template v-if="row.base_price && row.price < row.base_price">
                                                    <s class="text-muted ml-1">{{ row.base_price }}</s>
                                                    <span class="badge badge-pill badge-success ml-1">{{ $t('bulk_discount') }}</span>
                                                </template>
                                            </template>
                                        </el-table-column>

                                        <!-- quantity -->
                                        <el-table-column>
                                            <template
                                                slot-scope="{ $index, row }"
                                            >
                                                <base-button @click.native=" handleProductAdd($index) " class="edit" type="warning" size="sm" icon >
                                                    <i class="text-dtac-bt fa fa-plus" ></i>
                                                </base-button>
												
												<input @keydown="CheckIsNumber" @input="convertNumber(row)" type="text" class="form-control text-center" style="display:inline; width:30%; margin-right:10px"  v-model="row.quantity" >
                                                <!-- <span class="px-3"> {{ row.quantity }} </span> -->

                                                <base-button @click.native=" handleProductRemove( $index) "
                                                    class="edit"
                                                    type="warning"
                                                    size="sm"
                                                    icon
                                                >
                                                    <i class="text-dtac-bt fa fa-minus" ></i>
                                                </base-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </div>
							<div class="row mt-3 mb-3" v-if="SumPrice != 0">
								<div class="col-2">
								</div>
								<div class="col-10 text-right mr-3" v-if="params.shipping_cost != 0">
								ค่าขนส่ง  {{ params.shipping_cost }} บาท
								</div>
								<div class="col-10 text-right mr-3" v-if="params.shipping_cost != 0">
								ราคาสินค้า  {{ SumPrice }} บาท
								</div>
								<div class="col-10 text-right mr-3" v-if="params.discount == 0">
								รวมราคา  {{ SumPrice + params.shipping_cost  }} บาท
								</div>
								<div class="col-10 text-right mr-3" v-if="params.discount >0" >
								รวมราคา (หักส่วนลด) {{ SumPrice - params.discount + params.shipping_cost  }} บาท
								</div>
								<div class="col-10 text-right text-red mr-3" v-if="params.discount != 0 && !(params.discount > 0)" >
								 ส่วนลดไม่ถูกต้อง
								</div>


							</div>

                            <div class="row">
                                <div class="col-md-12">
                                    <label class="col-md-1 pl-2 col-form-label form-control-label" > Tag </label>
                                    <base-button :type="getTagType(item)" size="sm" v-for="item in tags" :key="item" @click="handleTagSelect(item)" class="product-tag">
                                        {{ item }}
                                    </base-button>
                                    -
                                    <base-button type="primary" size="sm" @click="clearTagSelect()" >Clear</base-button
                                    >
                                </div>
                            </div>

                            <el-table :data="queriedData" row-key="id" header-row-class-name="thead-light" @sort-change="sortChange" @selection-change="selectionChange"
                            >
                                <el-table-column>
                                    <template slot-scope="{ $index, row }">
                                        <div class="row">
                                            <div class="col-md-3">
                                                <img
                                                    :src="GetProductUrl(row.images)"
                                                    width="100px"
                                                    height="100px"
                                                />
                                            </div>
                                            <div class="col-md-7"> {{ row.name }} </div>
											<div class="col-md-2">
                                                <base-button @click.native="handleAddProductSelectV2(row)" class="edit" type="warning" size="sm" icon >
                                                    <i class="text-dtac-bt fa fa-plus" ></i> 
													{{ "  " + $t("add") }}
                                                </base-button>

											</div>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div
                            slot="footer"
                            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                            v-if="queriedData.length != 0"
                        >
                            <div class="">
                                <p class="card-category">
                                    {{ $t("data") }} {{ from + 1 }}
                                    {{ $t("to") }} {{ to }}
                                    {{ $t("of") }}
                                    {{ total }}
                                    <span v-if="selectedRows.length">
                                        - &nbsp; &nbsp;
                                        {{ selectedRows.length }}
                                        {{ $t("row_select") }}
                                    </span>
                                </p>
                            </div>
                            <base-pagination
                                class="pagination-no-border"
                                v-model="pagination.currentPage"
                                :per-page="pagination.perPage"
                                :total="total"
                            >
                            </base-pagination>
                        </div>
                    </card>
                </div>
            </div>
        </div>

        <!--  Birthday Modal (Buddhist year) -->
        <modal :show.sync="showBirthdayModal" modal-classes="modal-secondary">
            <template slot="header">
                <h5 class="modal-title">{{ $t('birthday_modal_title') }}</h5>
            </template>

            <div class="text-muted small mb-3">
                {{ $t('birthday_modal_hint') }}
            </div>

            <div class="row">
                <div class="col-md-3">
                    <base-input :label="$t('day')">
                        <el-select v-model="birthdayInput.day" filterable>
                            <el-option v-for="d in 31" :key="d" :label="d" :value="d"></el-option>
                        </el-select>
                    </base-input>
                </div>
                <div class="col-md-5">
                    <base-input :label="$t('month')">
                        <el-select v-model="birthdayInput.month" filterable>
                            <el-option
                                v-for="(name, idx) in monthOptions"
                                :key="idx + 1"
                                :label="name"
                                :value="idx + 1"
                            ></el-option>
                        </el-select>
                    </base-input>
                </div>
                <div class="col-md-4">
                    <base-input :label="$t('year_be')">
                        <el-select v-model="birthdayInput.yearBE" filterable>
                            <el-option
                                v-for="y in beYearOptions"
                                :key="y"
                                :label="y"
                                :value="y"
                            ></el-option>
                        </el-select>
                    </base-input>
                </div>
            </div>

            <div v-if="birthdayPreviewCE" class="alert alert-info py-2 mb-0">
                {{ $t('birthday') }}: {{ formatBirthdayBE(birthdayPreviewCE) }}
                <span class="text-muted small ml-2">(CE: {{ birthdayPreviewCE }})</span>
            </div>

            <template slot="footer">
                <button
                    type="button"
                    class="btn btn-md btn-primary"
                    :disabled="!birthdayPreviewCE"
                    @click="saveBirthday()"
                >
                    {{ $t('save') }}
                </button>
                <button
                    type="button"
                    class="btn btn-md btn-link ml-auto"
                    @click="showBirthdayModal = false"
                >
                    {{ $t('close') }}
                </button>
            </template>
        </modal>

        <!--  Modal -->
        <modal :show.sync="showSkuModal" modal-classes="modal-secondary">
            <form class="new-event--form" @submit.prevent="saveEvent">
				Product : {{  product.name }}

				<!-- Loop atrribute -->

				<div v-for="(attribute, index) in product.attributes" :key="index" class="row py-2" >
					<div class="col-md-6 col-lg-6">
						<base-input :value="attribute.variable" size="sm"/>
					</div>

					<div class="col-md-6 col-lg-6">
						<base-input>
                            <el-select v-model="product_variable_select[index]" :placeholder="$t('product')" :label="$t('product')" value-key="name"  >
								<template  v-for="(option) in attribute.options">
                                	<!-- #424 §8 F8: SKU mapped to a disabled WMS product = labelled, not selectable -->
                                	<el-option  :key="option.name" :label="option.name + ' (' + $t('wms_product_active.order_option_disabled') + ')'" :value="option" :disabled="true" v-if="skuOptionWmsInactive(option, inactiveWmsIds)"/>
                                	<el-option  :key="option.name" :label="option.name + ' (' + GetStockBalance(option) + ')'" :value="option" class="text-red" v-else-if="GetStockBalanceIsLock(option)"/>
                                	<el-option  :key="option.name" :label="option.name + ' (' + GetStockBalance(option) + ')'" :value="option" v-else />
								</template>
                            </el-select>
                        </base-input>
					</div>

				</div>
            </form>


			<div class="row" v-if="ProductVariableCheck != ''">
				<div class="col-md-12">
					<!-- Text warining -->
					<div class="alert alert-warning" role="alert">
						{{ ProductVariableCheck}}
						</div>
				</div>
			</div>


            <template slot="footer">
                <button 
					v-if="ProductVariableCheck == ''"
                    type="submit"
                    class="btn btn-md btn-primary"
                    @click="handleAddProductSkuSelect()"
                >
                    {{ $t("add") }}
                </button>

                <button
                    type="button"
                    class="btn btn-md btn-link ml-auto"
                    @click="showSkuModal = false"
                >
                    {{ $t("close") }}
                </button>
            </template>
        </modal>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import FileInput from "@/components/Inputs/FileInput";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { requestRefresh } from "@/utils/pageRefresh";
import formDraft from "@/mixins/formDraft";
import FormClearButton from "@/components/FormClearButton.vue";
import wmsProductRefetchOnActivate from "@/mixins/wmsProductRefetchOnActivate";
import { inactiveWmsIdSet, skuOptionWmsInactive as isSkuOptionWmsInactive, anySkuOptionWmsInactive } from "@/utils/wmsProductActive";

export default {
    mixins: [clientPaginationMixin, formDraft, wmsProductRefetchOnActivate],
    components: {
        FormClearButton,
        flatPicker,
        FileInput,
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        ...mapGetters({
            Product: "Product/getData",
            SaleChannelTable: "SaleChannel/getData",
            PaymentMethodTable: "PaymentMethod/getData",
            FullAddr: "Order/getAddress",
            ShippingProviderTable : "Order/getShippingProvider",
			isAgent : "Auth/isAgent",
			getUser : "Auth/getUser",
			getStock: "WmsProduct/getInventortySummary",
			// #424 §8 F8: active=all WMS list (disabled rows included) -> inactiveWmsIds
			WmsProductAll: "WmsProduct/getDataAll",
			
        }),
        // #424 §8 F8: ids of disabled WMS products; empty until the list loads (nothing disabled)
        inactiveWmsIds() {
            return inactiveWmsIdSet(this.WmsProductAll);
        },
		ProductVariableCheck(){

			try {
				if (this.product.attributes.length != this.product_variable_select.length) {
					return "กรุณาเลือกสินค้าให้ครบ"
				} 			

				// let check = true
				// this.product_variable_select.forEach((v,i)=>{
				// 	if (this.GetStockBalanceIsLock(v)) {
				// 		check = false
				// 	}
				// })

				// if (!check){
				// 	return "กรุณาเลือกสินค้าที่มีสต๊อกเพียงพอก่อนทำการเพิ่ม"
				// } else {
				// 	return ""
				// }
				return ""

			}
			catch (err){
				console.log("ProductVariableCheck",err)
			}


		},
		SumPrice(){
			let sum = 0
			this.sku_selected.forEach((v)=>{
				sum += (v.price * v.quantity)
			})
			return sum
		},
		// True only when the logged-in user can receive bulk-pricing tiers
		// — agents always pay the product base price. Mirrors the
		// server-side check in ResolveProductPrice (BO-Pricing.go).
		isCompanyUser(){
			return !this.isAgent
		},
		IsCOD(){
			let iscod = false
			let payment_method = this.PaymentMethodTable.filter(v=>{
				return v.id == this.params.bo_payment_method_id
			})

			if (payment_method.length > 0){
				iscod = payment_method[0].type == 2
			}
			return iscod
		},
        filteredAddress() {
            let result = this.FullAddr.filter(item => {

				let search = false
				// split with space 
				let key = this.params.recipient_address_district.split(" ")
				if (key.length == 1)
				{
					search = item.District.includes(key[0]) ||item.Zipcode == key[0]
				}

				if (key.length == 2)
				{
					search = (item.District.includes(key[0]) ||item.Zipcode == key[0]) && item.City.includes(key[1])
				}

				if (key.length == 3)
				{
					search = (item.District.includes(key[0]) ||item.Zipcode == key[0]) && item.City.includes(key[1]) && item.Province.includes(key[2])
				}

				
                return search
            });

            return result.slice(0, 15);
        },
        tableData() {
            if (this.SearchKeyword == "" && this.tag_select.length == 0)
                return this.Product;

            let result = this.Product.filter(item => {
                let tag_result = true;
                // console.log(this.tag_select);
				
                if (this.tag_select.length > 0) {
                    tag_result = false;
                    this.tag_select.forEach(tag => {
						let regex = new RegExp(tag, 'i')
                        if (
                            item.name.match(regex)
                            // item.name.includes(tag)
                        ) {
                            tag_result = true;
                        }
                    });
                }

				let regexKeyword = new RegExp(this.SearchKeyword, 'i')

                return  tag_result && item.name.match(regexKeyword)
            });
            return result;
        },
		tags() {
		let defaulttag =  []
			this.Product.forEach(item=>{
				// split tag
				let tags = item.tag.split(',')
				tags.forEach(t=>{
					// check default tag is exsit
					if(!defaulttag.includes(t)){
						defaulttag.push(t)
					}
				})
			})

			// Sort Tag
			return defaulttag.sort()
		},
		ShippingProviderTableFilter() {
			if (!this.shipping_config || this.shipping_config.length === 0) {
				return this.withSpecialProvider(this.ShippingProviderTable);
			}

			// Collect all allowed shipping provider IDs from all configurations
			let allowedProviderIds = new Set();

			// Iterate through all shipping configurations
			this.shipping_config.forEach(config => {
				// Add default shipping provider id if exists
				if (config.default && config.default.shipping_provider_id) {
					allowedProviderIds.add(config.default.shipping_provider_id);
				}

				// Add shipping provider IDs from shipping_map
				if (config.shipping_map && config.shipping_map.length > 0) {
					config.shipping_map.forEach(mapping => {
						if (mapping.shipping_provider_id) {
							allowedProviderIds.add(mapping.shipping_provider_id);
						}
					});
				}
			});

			// Filter ShippingProviderTable to only include allowed provider IDs.
			// Special delivery (id 9) is a manual ops choice not tied to the
			// sale-channel shipping_config, so always offer it.
			let filtered = this.ShippingProviderTable.filter(provider =>
				allowedProviderIds.has(provider.id)
			);
			return this.withSpecialProvider(filtered);
		},
		monthOptions() {
			const th = ["มกราคม","กุมภาพันธ์","มีนาคม","เมษายน","พฤษภาคม","มิถุนายน","กรกฎาคม","สิงหาคม","กันยายน","ตุลาคม","พฤศจิกายน","ธันวาคม"];
			const en = ["January","February","March","April","May","June","July","August","September","October","November","December"];
			return this.$i18n && this.$i18n.locale === "en" ? en : th;
		},
		beYearOptions() {
			const currentBE = new Date().getFullYear() + 543;
			const years = [];
			for (let y = currentBE; y >= currentBE - 100; y--) years.push(y);
			return years;
		},
		birthdayPreviewCE() {
			const { day, month, yearBE } = this.birthdayInput;
			if (!day || !month || !yearBE) return "";
			const yearCE = parseInt(yearBE, 10) - 543;
			const m = String(month).padStart(2, "0");
			const d = String(day).padStart(2, "0");
			const dt = new Date(yearCE, parseInt(m, 10) - 1, parseInt(d, 10));
			if (isNaN(dt.getTime()) || dt.getFullYear() !== yearCE || dt.getMonth() + 1 !== parseInt(m, 10) || dt.getDate() !== parseInt(d, 10)) {
				return "";
			}
			return `${yearCE}-${m}-${d}`;
		}
    },
	watch:{
		// Watch SumPrice changed
		SumPrice(newVal, oldVal){
			this.params.shipping_cost = 0
			if (newVal != oldVal)
			{
				this.shipping_cost.rate.forEach((v)=>{
					if (v.more_than_and_equal <= newVal && newVal <= v.less_than){
						this.params.shipping_cost = v.cost
						console.log("Set Shippingcost", this.params.shipping_cost)
					}
				})
			}
		}

	},
    data() {
        return {
            isOpen: false,
            results: [],
            search: "",
            isLoading: false,
            arrowCounter: -1,

            tableColumns: [],
            StorageID: 0,
            propsToSearch: [],
            selectedRows: [],
            showAddModal: false,
            SearchKeyword: "",
            customer_keyword: "",
            product_keywrod: "",
            sku_selected: [],
			shipping_cost: {
				default : 0 ,
				rate:[]
			},
            showBirthdayModal: false,
            birthdayInput: { day: "", month: "", yearBE: "" },
            params: {
				shipping_cost:0,
                bo_sale_channel_id: "",
                bo_payment_method_id: "",
                bo_customer_id: "",
                bo_customer_address_id: "",
                recipient_name: "",
                recipient_phone: "",
                recipient_birthday: "",
                recipient_address_detail: "",
                recipient_address_district_id: "",
                recipient_address_district: "",
                recipient_address_city_id: "",
                recipient_address_city: "",
                recipient_address_province_id: "",
                recipient_address_province: "",
                recipient_address_fulladdress: "",
                recipient_zipcode: "",
                recipient_region: "",
                recipient_region_code: "",
                seller_note: "",
                payment_files: "",
                payment_at: "",
				discount:0,
				shipping_provider_id: 1,
                products: []
            },
            ProductSelect: [],
            SkuTable: [],
            
            tag_select: [],
			showSkuModal:false,
			product:[],
			product_variable_select:[],
			address_key : [],
			shipping_config: [],

			// bo payment method
			// โอนเงิน 14
			// COD 12
			// เคลมสินค้า 15
			// shopee 18
			// lazada 19
			// Rabitlinepay 20
			// tiktok 21

			// shipping provider 1 = thaipost
			// shipping provieder 2 = kerry
			// shipping provieder 5 = dhl
			// shipping provieder 6 = MadameFin

			// shipping_config : [
			// 	{
			// 		sale_channel_id: 6 ,  // Line Official
			// 		default : {shipping_provider_id : "" , bo_payment_method_id : ""},
			// 		shipping_map : [
			// 			{bo_payment_method_id : 12 , shipping_provider_id : 2}, // COD 5=DHL
			// 			{bo_payment_method_id : 14 , shipping_provider_id : 1},
			// 			{bo_payment_method_id : 20 , shipping_provider_id : 1}
			// 		]
			// 	},
			// 	{
			// 		sale_channel_id: 7 ,  // Lazada
			// 		default : {shipping_provider_id : "" , bo_payment_method_id : ""},
			// 		shipping_map : [
			// 			{bo_payment_method_id : 12 , shipping_provider_id : 6},
			// 			{bo_payment_method_id : 14 , shipping_provider_id : 6},
			// 			{bo_payment_method_id : 20 , shipping_provider_id : 6}

			// 		]
			// 	},
			// 	{
			// 		sale_channel_id: 9 , // Rabbit Line Pay
			// 		default : {shipping_provider_id : "" , bo_payment_method_id : ""},
			// 		shipping_map : [
			// 			{bo_payment_method_id : 12 , shipping_provider_id : 2},
			// 			{bo_payment_method_id : 14 , shipping_provider_id : 1},
			// 			{bo_payment_method_id : 20 , shipping_provider_id : 1}
			// 		]
			// 	},
			// 	{
			// 		sale_channel_id: 11 , // Shoppee
			// 		default : {shipping_provider_id : "" , bo_payment_method_id : ""},
			// 		shipping_map : [
			// 			{bo_payment_method_id : 12 , shipping_provider_id : 6},
			// 			{bo_payment_method_id : 14 , shipping_provider_id : 6},
			// 			{bo_payment_method_id : 20 , shipping_provider_id : 6}
			// 		]
			// 	},
			// 	{
			// 		sale_channel_id: 12 , // Callcenter
			// 		default : {shipping_provider_id : "" , bo_payment_method_id : ""},
			// 		shipping_map : [
			// 			{bo_payment_method_id : 12 , shipping_provider_id : 2},
			// 			{bo_payment_method_id : 14 , shipping_provider_id : 1},
			// 			{bo_payment_method_id : 20 , shipping_provider_id : 1}
			// 		]
			// 	},
			// 	{
			// 		sale_channel_id: 13 , // Page
			// 		default : {shipping_provider_id : "" , bo_payment_method_id : ""},
			// 		shipping_map : [
			// 			{bo_payment_method_id : 12 , shipping_provider_id : 2},
			// 			{bo_payment_method_id : 14 , shipping_provider_id : 1},
			// 			{bo_payment_method_id : 20 , shipping_provider_id : 1}
			// 		]
			// 	},
			// 	{
			// 		sale_channel_id: 14 , // MadameFin
			// 		default : {shipping_provider_id : "" , bo_payment_method_id : ""},
			// 		shipping_map : [
			// 			{bo_payment_method_id : 12 , shipping_provider_id : 1},
			// 			{bo_payment_method_id : 14 , shipping_provider_id : 1},
			// 			{bo_payment_method_id : 20 , shipping_provider_id : 1}
			// 		]
			// 	},
			// 	{
			// 		sale_channel_id: 15 , // Agent
			// 		default : {shipping_provider_id : "" , bo_payment_method_id : ""},
			// 		shipping_map : [
			// 			{bo_payment_method_id : 12 , shipping_provider_id : 2},
			// 			{bo_payment_method_id : 14 , shipping_provider_id : 2},
			// 			{bo_payment_method_id : 20 , shipping_provider_id : 2}
			// 		]
			// 	},
			// 	{
			// 		sale_channel_id: 16 , // รับหน้าร้าน
			// 		default : {shipping_provider_id : 6 , bo_payment_method_id : ""}, 
			// 		shipping_map : [
			// 			{bo_payment_method_id : 12 , shipping_provider_id : 6},
			// 			{bo_payment_method_id : 14 , shipping_provider_id : 6},
			// 			{bo_payment_method_id : 20 , shipping_provider_id : 6}
			// 		]
			// 	},
			// ]
			// Attribute for modal
        };
    },
    async mounted() {


		if (this.FullAddr.length == 0) {
			this.listFullAddr();
		}

        this.listStock();
        // #424 §8 F8: full WMS list (incl. disabled) -> SKUs mapped to a disabled product are not selectable
        this.listWmsProduct({ active: "all" });
        this.listSaleChannel();
        this.listPaymentChannel();

		// Show product from self platform and status is active
		this.listProduct({status:1,platform_id:1});

        this.pagination.perPage = 5;
        document.addEventListener("click", this.handleClickOutside);

		// Get Shipping Config
		try {
			let result =  await this.GetShippingInfo()
			console.log("Shipping Info",result)
			this.shipping_cost = result.data.Datum.shipping_cost
			this.shipping_config = result.data.Datum.shipping_config

			// Set default to ""
			this.shipping_config.forEach(v =>{
				v.default.shipping_provider_id = ""
				v.default.bo_payment_method_id = ""
			})

		} catch (e){
		console.log(e)
			swal.fire({
				text: "",
				title: "ข้อมูลค่าจัดส่งผิดพลาด",
				icon: "error",
				confirmButtonClass: "btn btn-danger btn-fill",
				buttonsStyling: false
			}).then(() => {
				requestRefresh("/backoffice/orders");
				this.$router.push({ name: "BOOrders" });
			});
		}
		this.Initshipping()
    },
    destroyed() {
        document.removeEventListener("click", this.handleClickOutside);
    },
    methods: {
        ...mapActions({
            searchCustomer: "Customer/searchData",
            listProduct: "Product/listDataV1",
            listFullAddr: "Order/listAddressV2",
            GetShippingInfo: "Order/GetShippingInfo",
            createData: "Order/createData",
            listSaleChannel: "SaleChannel/listData",
            listPaymentChannel: "PaymentMethod/listData",
            listSku: "Product/listSku",
			listStock: "WmsProduct/listWmsInventorySummary",
			// #424 §8 F8: WmsProduct/listData({ active: "all" }) fills WmsProduct/getDataAll
			// (listProduct is already Product/listDataV1 on this page)
			listWmsProduct: "WmsProduct/listData",
        }),
        // #424 §8 F8: template helper (see src/utils/wmsProductActive.js)
        skuOptionWmsInactive(option, inactiveIds) {
            return isSkuOptionWmsInactive(option, inactiveIds);
        },
        // #424 §8.1 F8b: every add path that bypasses the dropdown checks the options it
        // is about to add; a disabled WMS product -> error swal, nothing added (true).
        blockIfWmsInactive(options, productName) {
            if (!anySkuOptionWmsInactive(options, this.inactiveWmsIds)) return false;
            swal.fire({
                title: this.$t("wms_product_active.scan_inactive"),
                text: productName || "",
                icon: "error",
                confirmButtonClass: "btn btn-danger btn-fill",
                buttonsStyling: false
            });
            return true;
        },
        // #424 §8 F8 / §7 F7: keep-alive re-activation reloads the active=all list
        refetchWmsProducts() {
            return this.listWmsProduct({ active: "all" });
        },

		// Always include Special delivery (id 9) in the change-shipping
		// dropdown regardless of the sale-channel shipping_config.
		withSpecialProvider(list) {
			const SPECIAL_ID = 9;
			if (list.some(p => p.id === SPECIAL_ID)) {
				return list;
			}
			const special = this.ShippingProviderTable.find(p => p.id === SPECIAL_ID);
			return special ? [...list, special] : list;
		},

		Initshipping(){

			this.params.bo_payment_method_id = this.GetPaymentMethod(this.getUser.sale_channel_id)
			this.params.shipping_provider_id = this.GetShippingProvider(this.getUser.sale_channel_id) 

			// Fix to kerry
			// if (this.isAgent) {
			// 	console.log("I am agent",this.getUser.sale_channel_id)
			// 	this.params.shipping_provider_id = 2
			// }

		},
		onPaymentChange(){
			console.log("Payment Change [sale_channel_id,bo_payment_method_id]",this.getUser.sale_channel_id,this.params.bo_payment_method_id)
			this.shipping_config.forEach(v =>{
				if (v.sale_channel_id == this.getUser.sale_channel_id) {
					v.shipping_map.forEach(m =>{
						if (m.bo_payment_method_id == this.params.bo_payment_method_id) {
							this.params.shipping_provider_id = m.shipping_provider_id
							console.log("Change to ",m.shipping_provider_id)
						}
					})
				}
			})
		},
		GetPaymentMethod(sale_channel_id) {
			let id = 0
			this.shipping_config.forEach(v =>{
				if (v.sale_channel_id == sale_channel_id) {
					id =  v.default.bo_payment_method_id
				}
			})
			console.log("Get Payment Method sale_channel_id" , sale_channel_id,id)
			return id == 0 ? "" : id
		},
		GetShippingProvider(sale_channel_id) {
			let id = 0
			this.shipping_config.forEach(v =>{
				if (v.sale_channel_id == sale_channel_id) {
					id = v.default.shipping_provider_id
				}
			})
			console.log("Get Shipping sale_channel_id" , sale_channel_id,id)
			return id == 0 ? "" : id
		},


		CheckIsNumber(e){
			if (!/\d/.test(e.key)) {
				e.preventDefault();
			}
		},
		convertNumber(row){
			if (typeof row.quantity === "string")
			{
				row.quantity = parseInt(row.quantity)
			}
			this.recalcLinePriceByRow(row);
		},
		// Re-pick the unit price for a line based on its current quantity
		// and bulk-pricing tiers. Mirrors backend ResolveProductPrice so
		// the previewed total matches what OrderCreate will compute.
		resolveTierPrice(basePrice, tiersRaw, qty){
			if (!this.isCompanyUser) return basePrice;
			if (!tiersRaw) return basePrice;
			let tiers = tiersRaw;
			if (typeof tiersRaw === "string") {
				try { tiers = JSON.parse(tiersRaw); }
				catch (e) { return basePrice; }
			}
			if (!Array.isArray(tiers) || tiers.length === 0) return basePrice;
			const sorted = tiers.slice().sort((a,b) => Number(a.min_qty) - Number(b.min_qty));
			let price = basePrice;
			for (const t of sorted) {
				if (Number(qty) >= Number(t.min_qty)) {
					price = Number(t.price);
				} else {
					break;
				}
			}
			return price;
		},
		recalcLinePrice(idx){
			if (idx < 0 || idx >= this.sku_selected.length) return;
			this.recalcLinePriceByRow(this.sku_selected[idx]);
		},
		recalcLinePriceByRow(row){
			if (!row) return;
			const newPrice = this.resolveTierPrice(row.base_price, row.price_tiers, row.quantity);
			if (row.price !== newPrice) {
				this.$set(row, "price", newPrice);
			}
		},

        tagIsSelect(tag) {
            return true;
        },
        handleTagSelect(item) {
            // console.log("toggle select" + item);
            // add tag if not exist
            if (this.tag_select.indexOf(item) == -1) {
                this.tag_select.push(item);
            } else {
                // remove tag if exist
                this.tag_select.splice(this.tag_select.indexOf(item), 1);
            }
        },
        getTagType(item) {
            if (this.tag_select.indexOf(item) == -1) {
                return "secondary";
            } else {
                return "primary";
            }
        },

        clearTagSelect() {
            this.tag_select = [];
        },

        handleClickOutside(event) {
            if (!this.$el.contains(event.target)) {
                this.arrowCounter = -1;
                this.isOpen = false;
            }
        },
        onArrowDown() {
            if (this.arrowCounter < this.results.length) {
                this.arrowCounter = this.arrowCounter + 1;
            }
        },
        onArrowUp() {
            if (this.arrowCounter > 0) {
                this.arrowCounter = this.arrowCounter - 1;
            }
        },
        onEnter() {
            this.search = this.results[this.arrowCounter];
            this.arrowCounter = -1;
            this.isOpen = false;
        },

        onChange() {
            this.isOpen = true;
        },

        setResult(r) {
            // console.log(r);
            this.params.recipient_address_district_id = r.DistrictID;
            this.params.recipient_address_city_id = r.CityID;
            this.params.recipient_address_province_id = r.ProvinceID;
            this.params.recipient_address_district = r.District;
            this.params.recipient_address_city = r.City;
            this.params.recipient_address_province = r.Province;
            this.params.recipient_zipcode = r.Zipcode;
            this.isOpen = false;
        },

        // formDraft contract (spec 2026-10-07-bo-form-draft-clear-design.md
        // §3 F1, §4 A5). Every data() key goes back to its initial value:
        // customer search, recipient/address, birthday, payment method / date
        // / slip, shipping provider + cost, discount, seller note, the chosen
        // products (sku_selected), tag filter, product search, SKU modal.
        // Kept on purpose: shipping_cost (rate table) and shipping_config are
        // lookups loaded once in mounted(), not user input — wiping them would
        // leave the next order without shipping rates. Pagination keeps the
        // page size mounted() sets.
        resetForm() {
            const keep = {
                shipping_cost: this.shipping_cost,
                shipping_config: this.shipping_config
            };
            const fresh = this.$options.data.call(this);
            Object.keys(fresh).forEach(k => {
                if (!Object.prototype.hasOwnProperty.call(keep, k)) {
                    this[k] = fresh[k];
                }
            });
            if (this.pagination) this.pagination.perPage = 5;
            // Same defaults mounted() applies after the shipping config loads.
            this.Initshipping();
            // <file-input> keeps its own file list and the native <input>
            // keeps its value; clear both so the slip label resets too.
            const slip = this.$refs.paymentSlipInput;
            if (slip) {
                if (typeof slip.clearFile === "function") slip.clearFile();
                const el = slip.$el && slip.$el.querySelector && slip.$el.querySelector("input[type=file]");
                if (el) el.value = "";
            }
            this.$nextTick(() => {
                const v = this.$refs.formValidator;
                if (v && typeof v.reset === "function") v.reset();
            });
        },

        async handleSaveOrder() {
            // console.log("handle save");
            let valid = await this.$refs.formValidator.validate();
            if (!valid) return;

            if (this.sku_selected.length == 0) {
                swal.fire({
                    text: "",
                    title: "กรุณาเลือกสินค้า",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
				return;
            }

			if (this.params.bo_payment_method_id == 0 || this.params.bo_payment_method_id == ""){
				 swal.fire({
                    text: "",
                    title: "กรุณาเลือกช่องทางการชำระเงิน",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
				return;
			}

			if (this.params.payment_at == "" && !this.IsCOD){
				 swal.fire({
                    text: "",
                    title: "กรุณาระบุวันที่ชำระเงิน",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
				return;
			}

			// Check discount
			let discountFloat = parseFloat(this.params.discount)

			if (isNaN(discountFloat)) {
				 swal.fire({
                    text: "",
                    title: "ส่วนลดไม่ถูกต้อง",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
				return
			}

			var regIsMobileNumber = /^[0]\d{9}$/g;
			if(!regIsMobileNumber.test(this.params.recipient_phone)){
				 swal.fire({
                    title: "เบอร์โทรศัพท์ไม่ถูกต้อง",
                    text: "",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
				return
			}

			this.params.discount = discountFloat

            // Check quantity
			try {
				for (let i=0;i<this.sku_selected.length ; i++) {
					this.sku_selected[i].quantity = parseInt(this.sku_selected[i].quantity)
				}
			}
			catch(err){
				console.log(err)
				 swal.fire({
                    title: "จำนวนสินค้าไม่ถูกต้อง",
                    text: "",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
				return
			}


            this.params.products = this.sku_selected;
			this.params.recipient_address_fulladdress = this.params.recipient_address_detail + " " + this.params.recipient_address_district + " " + this.params.recipient_address_city + " " + this.params.recipient_address_province;
			console.log("B")
			console.log(this.params)
			this.isLoading = true

			try {
				let resp = await this.createData(this.params);
				console.log(resp)
				console.log("D")
				this.isLoading = false
				// Spec 2026-10-07-bo-form-draft-clear-design.md §4 A5: the tab
				// stays in the keep-alive cache, so empty it before leaving.
				// Only reached on success — validation errors return above and
				// a failed save lands in the catch below with the draft intact.
				this.afterSaveReset();
				swal.fire({
					title: this.$t("create_success"),
					text: ``,
					icon: "success",
					confirmButtonClass: "btn btn-success btn-fill",
					buttonsStyling: false
				}).then(() => {
					// goto order page (form already cleared by afterSaveReset)
					requestRefresh("/backoffice/orders");
					this.$router.push({ name: "BOOrders" ,params :{detail:resp.data.Datum}});
				}).catch(err=>{
					console.log("E")
					console.log(err)
				});
			} catch(err){
					console.log("F")
					this.isLoading = false
                    swal.fire({
                        title: this.$t(err.response.data.Msg),
                        text: this.getErrorText(err.response.data),
                        icon: "error",
                        confirmButtonClass: "btn btn-danger btn-fill",
                        buttonsStyling: false
                    });
			}
        },


        async handleAddProductSelectV2(product) {
            // check sku_selected exsit

			console.log("Product",product)
			// if product has 1 sku
			let attr = JSON.parse(product.attributes);
			// check can't parse json
			if (attr == null) {
				swal.fire({
                    title: "Error",
                    text: "ข้อมูลสินค้าไม่ถูกต้อง",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
				return
			}

			console.log("Attributes",attr)

			if (product.is_comboset){
				// Handle comboset products
				if (attr.length != 1 || !attr[0].options || attr[0].options.length === 0) {
					swal.fire({
						title: "Error",
						text: "ข้อมูล Comboset ไม่ถูกต้อง",
						icon: "error",
						confirmButtonClass: "btn btn-danger btn-fill",
						buttonsStyling: false
					});
					return;
				}

				// #424 §8.1 F8b: comboset auto-add — any option on a disabled WMS product blocks it
				if (this.blockIfWmsInactive(attr[0].options, product.name)) return;

				let sku_code = product.code + "-" + attr[0].variable;

				// Check if already added
				let index = this.sku_selected.findIndex(item => {
					return item.sku_code == sku_code;
				});

				if (index == -1) {
					// Convert all options in attr[1] to wms_map_per_unit
					let wms_map_per_unit = [];

					for (let i = 0; i < attr[0].options.length; i++) {
						let option = attr[0].options[i];
						let wms_product_id = 0;
						let bo_product_random_id = 0;

						try {
							wms_product_id = option.wms_map[0].wms_product_id;
						} catch (err) {
							console.log("wms_product_id error for option:", option.name, err);
							swal.fire({
								title: "Error",
								text: "ไม่พบ WMS Map สำหรับสินค้า: " + option.name,
								icon: "error",
								confirmButtonClass: "btn btn-danger btn-fill",
								buttonsStyling: false
							});
							return;
						}

						try {
							bo_product_random_id = option.wms_map[0].wms_product_random.bo_product_random_id;
						} catch (err) {
							console.log("bo_product_random_id error:", err);
						}

						wms_map_per_unit.push({
							wms_product_id: wms_product_id,
							quantity: 1,
							bo_product_random_id: bo_product_random_id
						});
					}

					console.log("Comboset WMS MAP", wms_map_per_unit);

					this.sku_selected.push({
						product_id: product.id,
						product_name: product.name,
						bo_product_sku_id: 0,
						sku_code: sku_code,
						sku_name: sku_code,
						price: product.price,
						base_price: product.price,
						price_tiers: product.price_tiers,
						quantity: 1,
						wms_map_per_unit: wms_map_per_unit
					});
				} else {
					this.sku_selected[index].quantity += 1;
					this.recalcLinePrice(index);
				}

				return;
			}


			console.log("Attr",attr)
			this.product_variable_select = []
			// Generate SKU 

			let autoAdd = true
			for (let i = 0; i < attr.length; i++) {
				if (attr[i].options.length == 1) {
					// Check Stock Available
					// if (this.GetStockBalanceIsLock(attr[i].options[0])) {
					// 	autoAdd = false
					// }
				} else {
					autoAdd = false
				}
			}

			console.log("Auto Add",autoAdd)

			if (autoAdd) {
				// #424 §8.1 F8b: one-option-per-attribute auto-add skips the dropdown
				if (this.blockIfWmsInactive(attr.filter(a => a.options.length === 1).map(a => a.options[0]), product.name)) return

				// Get SKU ID
				let sku_code = product.code 
				for (let i = 0; i < attr.length; i++) {
					if (attr[i].options.length == 1) {
							sku_code = sku_code+ "-" + attr[i].options[0].name
					}
				}

				console.log("SKU CODE",sku_code)

				
				
				// aready add
				let index = this.sku_selected.findIndex(item => {
					return item.sku_code == sku_code;
				});

				console.log("Index",index)

				if (index == -1) {


					let wms_map_per_unit = []

					for (let i = 0; i < attr.length; i++) {
						let wms_product_id = 0 
						let bo_product_random_id = 0
						try {
							wms_product_id = attr[i].options[0].wms_map[0].wms_product_id
						} catch (err){
							console.log("wms_product_id",err)
							swal.fire({
								title: "Error",
								text: "ไม่พบ WMS Map สำหรับสินค้านี้",
								icon: "error",
								confirmButtonClass: "btn btn-danger btn-fill",
								buttonsStyling: false
							});
							return
						}

						try {
							bo_product_random_id = attr[i].options[0].wms_map[0].wms_product_random.bo_product_random_id
						} catch (err) {
							console.log("bo_product_random_id",err)
						}

						wms_map_per_unit.push({wms_product_id :wms_product_id, quantity: 1,bo_product_random_id:bo_product_random_id})
						
					}

					console.log("WMS MAP",wms_map_per_unit)
				

					// check mws map is valid
					this.sku_selected.push({
						product_id: product.id,
						product_name: product.name,
						bo_product_sku_id: 0,
						sku_code: sku_code,
						sku_name: sku_code,
						price: product.price,
						base_price: product.price,
						price_tiers: product.price_tiers,
						quantity: 1,
						wms_map_per_unit : wms_map_per_unit
					});
				} else {
					this.sku_selected[index].quantity += 1;
					this.recalcLinePrice(index);
				}

				return
			}

			this.product = JSON.parse(JSON.stringify(product));
			this.product.attributes = JSON.parse(JSON.stringify(attr))
			this.product.attributes.forEach(item => {
				item.selected = ""
			})
			this.showSkuModal = true
            
            
        },
        async handleAddProductSelect(product) {
            // check sku_selected exsit

			// if product has 1 sku
			let attr = JSON.parse(product.attributes);
			// check can't parse json
			if (attr == null) {
				swal.fire({
                    title: "Error",
                    text: "ข้อมูลสินค้าไม่ถูกต้อง",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
				return
			}

			// console.log(attr)
			this.product_variable_select = []
			// Generate SKU 
			if (attr.length == 1) {
				if (attr[0].options.length == 1)
				{
					// Check Stock Available
					if (this.GetStockBalanceIsLock(attr[0].options[0])) {
						swal.fire({
							title: "สินค้ามีจำนวนต่ำกว่าที่กำหนด ("+ this.GetStockBalance(attr[0].options[0]) +")",
							text: "",
							icon: "error",
							confirmButtonClass: "btn btn-danger btn-fill",
							buttonsStyling: false
						});
						return
					}

					// Get SKU ID
					let sku_code = product.code + "-" + attr[0].options[0].name
					// let resp = await this.listSku({sku_code : sku_code})

					// console.log(resp.data.Data)

					// if (resp.data.Data == null){
					// 	swal.fire({
					// 		title: "Error",
					// 		text: "ไม่พบ SKU นี้",
					// 		icon: "error",
					// 		confirmButtonClass: "btn btn-danger btn-fill",
					// 		buttonsStyling: false
					// 	});
					// 	return
					// }

					// let sku = resp.data.Data[0]

					let index = this.sku_selected.findIndex(item => {
						return item.sku_code == sku_code;
					});

					if (index == -1) {

						let wms_product_id = 0 
						let bo_product_random_id = 0
						try {
							wms_product_id = attr[0].options[0].wms_map[0].wms_product_id
							bo_product_random_id = attr[0].options[0].wms_map[0].wms_product_random.bo_product_random_id
						} catch (err){
							console.log(err)
						}

						// check mws map is valid
						this.sku_selected.push({
							product_id: product.id,
							product_name: product.name,
							bo_product_sku_id: 0,
							sku_code: sku_code,
							sku_name: sku_code,
							price: product.price,
							base_price: product.price,
							price_tiers: product.price_tiers,
							quantity: 1,
							wms_map_per_unit : [{wms_product_id :wms_product_id, quantity: 1,bo_product_random_id:bo_product_random_id}]
						});
					} else {
						this.sku_selected[index].quantity += 1;
						this.recalcLinePrice(index);
					}

					return
				}
			}

			this.product = JSON.parse(JSON.stringify(product));
			this.product.attributes = JSON.parse(JSON.stringify(attr))
			this.product.attributes.forEach(item => {
				item.selected = ""
			})
			this.showSkuModal = true
            
        },
		async handleAddProductSkuSelect(){
			// Check product select all attribute
			let sku_code = this.product.code 

			// console.log("sku",this.product_variable_select)
			// console.log("pvs",this.product_variable_select)
			if (this.product_variable_select.length == 0){
					swal.fire({
						title: "กรุณาเลือกสินค้า",
						text: "",
						icon: "error",
						confirmButtonClass: "btn btn-danger btn-fill",
						buttonsStyling: false
					});
					return
			}

			let cnt = 0
			this.product_variable_select.forEach((e)=>{
				cnt++
			})
			// check product select all attribute
			if (cnt != this.product.attributes.length){
					swal.fire({
						title: "กรุณาเลือกสินค้าให้ครบ",
						text: "",
						icon: "error",
						confirmButtonClass: "btn btn-danger btn-fill",
						buttonsStyling: false
					});
					return
			}

			// #424 §8.1 F8b: option picked before the WMS list finished loading
			if (this.blockIfWmsInactive(this.product_variable_select, this.product.name)) return

			let wms_map_per_unit = []
			this.product_variable_select.forEach(item => {
				if (item == ""){
					swal.fire({
						title: "กรุณาเลือกสินค้า",
						text: "",
						icon: "error",
						confirmButtonClass: "btn btn-danger btn-fill",
						buttonsStyling: false
					});
					return
				}
				sku_code += "-" +item.name

				let wms_product_id = 0
				let bo_product_random_id = 0
				try {
					wms_product_id = item.wms_map[0].wms_product_id
					bo_product_random_id = item.wms_map[0].wms_product_random.bo_product_random_id
				} catch (err){
					console.log(err)
				}

				// check wms aready exitst
				let result = wms_map_per_unit.find(wms => {
					return (wms.wms_product_id == wms_product_id && wms.wms_product_id != 0 ) || (wms.bo_product_random_id == bo_product_random_id && wms.bo_product_random_id != 0)
				})
				if (result == null ){
					wms_map_per_unit.push({wms_product_id :wms_product_id, quantity: 1,bo_product_random_id: bo_product_random_id})
				} else {
					result.quantity += 1
				}

			})


			// console.log(sku_code)
			// let resp = await this.listSku({sku_code : sku_code})

			// if (resp.data.Data == null){
			// 	this.showSkuModal = false
			// 	swal.fire({
			// 		title: "ไม่พบ SKU นี้ในคลังสินค้า",
			// 		text: "กรุณาติดต่อฝ่ายคลังสินค้า",
			// 		icon: "error",
			// 		confirmButtonClass: "btn btn-danger btn-fill",
			// 		buttonsStyling: false
			// 	});
			// 	return
			// }

			// let sku = resp.data.Data[0]


			let index = this.sku_selected.findIndex(item => {
				return item.sku_code == sku_code;
			});

			if (index == -1) {
				this.sku_selected.push({
					product_id: this.product.id,
					product_name: this.product.name,
					bo_product_sku_id: 0,
					sku_code: sku_code,
					sku_name: sku_code,
					price: this.product.price,
					base_price: this.product.price,
					price_tiers: this.product.price_tiers,
					quantity: 1,
					wms_map_per_unit: wms_map_per_unit
				});
			} else {
				this.sku_selected[index].quantity += 1;
				this.recalcLinePrice(index);
			}

			this.showSkuModal = false


		},

        handleProductAdd(index) {
            this.sku_selected[index].quantity += 1;
            this.recalcLinePrice(index);
        },
        handleProductRemove(index) {
            this.sku_selected[index].quantity -= 1;

            if (this.sku_selected[index].quantity == 0) {
                this.sku_selected.splice(index, 1);
                return;
            }
            this.recalcLinePrice(index);
        },

        handleSearchCustomer() {
            // console.log("search customer");
            this.searchCustomer({ phone: this.customer_keyword })
                .then(resp => {
                    if (resp.data.Data.length > 0) {
                        let customer = resp.data.Data[0];
                        // console.log(customer);
                        this.params.bo_customer_id = customer.id;
                        this.params.bo_customer_address_id = customer.address[0].id;
                        this.params.recipient_name = customer.fname + " " + customer.lname;
                        // phone
                        this.params.recipient_phone = customer.phone;
                        // address
                        this.params.recipient_address_detail = customer.address[0].address;
                        // distrcit
                        this.params.recipient_address_district_id = customer.address[0].district_id;
                        this.params.recipient_address_district = customer.address[0].district;

                        // city
                        this.params.recipient_address_city_id = customer.address[0].city_id;
                        this.params.recipient_address_city = customer.address[0].city;

                        // province
                        this.params.recipient_address_province_id = customer.address[0].province_id;
                        this.params.recipient_address_province = customer.address[0].province;

                        // zipcode
                        this.params.recipient_zipcode = customer.address[0].zipcode;

                        // birthday: backend sends ISO datetime; display only if valid (not the placeholder 1980/0001/etc.)
                        if (customer.birthday) {
                            const ce = customer.birthday.substring(0, 10);
                            const year = parseInt(ce.substring(0, 4), 10);
                            this.params.recipient_birthday = (year > 1900 && year < 9999) ? ce : "";
                        } else {
                            this.params.recipient_birthday = "";
                        }

                        this.recipient_region = "TH";
                        this.recipient_region_code = "TH";
                    } else {
                        swal.fire({
                            title: "ไม่พบข้อมูล",
                            text: "",
                            icon: "info",
                            confirmButtonClass: "btn btn-danger btn-fill",
                            buttonsStyling: false
                        });
                    }
                })
                .catch(err => {
					swal.fire({
                            title: "ไม่พบข้อมูล",
                            text: "",
                            icon: "info",
                            confirmButtonClass: "btn btn-danger btn-fill",
                            buttonsStyling: false
                        });
                });
        },

        handleDelete(index, row) {
            swal.fire({
                title: this.$t("delete_confirm"),
                text: this.$t("delete_confirm_question") + row.Name,
                icon: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn btn-success btn-fill",
                cancelButtonClass: "btn btn-danger btn-fill",
                confirmButtonText: this.$t("confirm"),
                cancelButtonText: this.$t("cancel"),
                buttonsStyling: false
            }).then(result => {
                //  let index = this.ProductSelect.indexOf(row)
                this.ProductSelect.splice(index, 1);
            });
        },

        selectionChange(selectedRows) {
            this.selectedRows = selectedRows;
        },
        filesChange(files) {
            if (files[0].type != "image/png" && files[0].type != "image/jpeg") {
                swal.fire({
                    title: "Error",
                    text: "กรุณาเลือกไฟล์รูปภาพ",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
            } 
			
			if (files[0].size > 1024 * 1024 *2 ) {
				swal.fire({
                    title: "Error",
                    text: "ขนาดไฟล์รูปภาพต้องไม่เกิน 2 MB",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
                return;
			}
			const reader = new FileReader();
            reader.readAsDataURL(files[0]);
            reader.onload = () => {
                this.params.payment_files = reader.result;
			console.log(reader.result)
            };
        },
		GetStockBalance(option){

			let stock = this.getStock.filter(s=>{
				return s.product_id == option.wms_map[0].wms_product_id
			})

			if (stock.length == 0) {
				return 0
			}

			return stock[0].balance
		},

		GetStockBalanceIsLock(option){

			let stock = this.getStock.filter(s=>{
				return s.product_id == option.wms_map[0].wms_product_id
			})

			if (stock.length == 0) {
				console.log("Stock Not found",option.wms_map[0].wms_product_id)
				return true
			}

			return stock[0].balance <= stock[0].threshold
		},
		openBirthdayModal() {
			if (this.params.recipient_birthday) {
				const [y, m, d] = this.params.recipient_birthday.split("-").map(s => parseInt(s, 10));
				if (y && m && d) {
					this.birthdayInput = { day: d, month: m, yearBE: y + 543 };
				}
			} else {
				this.birthdayInput = { day: "", month: "", yearBE: "" };
			}
			this.showBirthdayModal = true;
		},
		clearBirthday() {
			this.params.recipient_birthday = "";
			this.birthdayInput = { day: "", month: "", yearBE: "" };
		},
		saveBirthday() {
			if (!this.birthdayPreviewCE) {
				swal.fire({
					title: this.$t("birthday_invalid"),
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
				return;
			}
			this.params.recipient_birthday = this.birthdayPreviewCE;
			this.showBirthdayModal = false;
		},
		formatBirthdayBE(ce) {
			if (!ce) return "";
			const [y, m, d] = ce.split("-").map(s => parseInt(s, 10));
			if (!y || !m || !d) return "";
			const months = this.monthOptions;
			return `${d} ${months[m - 1]} ${y + 543}`;
		},
		GetProductUrl(filename){
			return process.env.VUE_APP_API_BASE_URL + "/files/products/" + filename
		}
    }
};
</script>
<style>
.autocomplete {
    position: relative;
}

.autocomplete-results {
    padding: 0;
    margin: 0;
    border: 1px solid #eeeeee;
    height: 120px;
    min-height: 1em;
    max-height: 6em;
    overflow: auto;
}

.autocomplete-result {
    list-style: none;
    text-align: left;
    padding: 4px 2px;
    cursor: pointer;
}

.autocomplete-result:hover {
    background-color: #01659e;
    color: white;
}

.autocomplete-result.is-active,
.autocomplete-result:hover {
    background-color: #4aae9b;
    color: white;
}

.product-tag {
  /* background-color: #c1d1fa; */
  /* z-index: 1000;
  transform: scale(1.5) perspective(1px) */
  font-size : 1.1rem
}
</style>
